<template>
	<div>
		<swiper class="pt-md-1" id="menu-horizon" :options="swiperOption">
			<template v-if="action">
				<swiper-slide v-for="tab in tabsComputed" :key="tab.label">
					<a @click.stop.prevent="action(tab)" href="" :class="{ active: tab.active }">{{ $t(tab.label) }}</a>
				</swiper-slide>
			</template>
			<template v-else>
				<swiper-slide v-for="(tab, index) in tabsComputed" :key="tab.label" :class="`menu_${tab.href}`">
					<b-button v-show="tab.dropdown" :aria-controls="`${collapse_prefix}-${index}`" :aria-expanded="String(index === open_index)" @click="selectFirstByDefault(index)"><font-awesome-icon v-if="tab.icon" :icon="tab.icon" /> {{ $t(tab.label) }}<b-badge v-if="tab.badge !== undefined" pill variant="primary" class="ml-1">{{ tab.badge }}</b-badge></b-button>
					<!-- Onglet annoncé mais pas encore accessible : la raison est dite au survol plutôt que
					     de laisser l'utilisateur buter sur un écran vide. -->
					<span v-show="!tab.dropdown && tab.disabled" v-b-tooltip.hover :title="tab.disabled_reason ? $t(tab.disabled_reason) : ''" class="tab-disabled"> <font-awesome-icon v-if="tab.icon" :icon="tab.icon" /> {{ $t(tab.label) }}</span>
					<router-link v-show="!tab.dropdown && !tab.disabled" :to="{ name: tab.href, params: tab.params }" v-on:click.native="notifyClickSuperTab(tab)" title="" :class="{ active: tab.active }" replace > <font-awesome-icon v-if="tab.icon" :icon="tab.icon" /> {{ $t(tab.label) }}<b-badge v-if="tab.badge !== undefined" pill variant="primary" class="ml-1">{{ tab.badge }}</b-badge></router-link>
				</swiper-slide>
			</template>
		</swiper>
		<template v-for="(tab, index) in tabsComputed">
	        <b-collapse v-if="tab.dropdown" :id="`${collapse_prefix}-${index}`" :key="tab.label" :visible="index === open_index">
	            <div class="container-fluid">
	                <div class="row">
	                    <template v-for="sub_tab in tab.dropdown">
	                    	<div v-if="!sub_tab.hidden" class="col-6 col-sm-auto mb-3" :key="sub_tab.label">
								<router-link :to="{ name: sub_tab.href, params: sub_tab.params }" v-on:click.native="notifyClickTab(tab)" title="" :class="{ active: sub_tab.active }" replace>{{ $t(sub_tab.label) }}<b-badge v-if="sub_tab.badge !== undefined" pill variant="primary" class="ml-1">{{ sub_tab.badge }}</b-badge></router-link>
							</div>
	                	</template>
	                </div>
	            </div>
	        </b-collapse>
	    </template>
    </div>
</template>

<script type="text/javascript">
	import { EventBus } from 'EventBus'
	import 'swiper/dist/css/swiper.css'
	import { swiper, swiperSlide } from 'vue-awesome-swiper'
	import _cloneDeep from 'lodash/cloneDeep'

	export default {
        props: {
            action: { type: Function, default: null },
            /* Onglets : {label, href, params, icon, badge, active, hidden, dropdown}.
               disabled grise l'onglet sans le masquer — il annonce ce qui existera, ou ce qui n'a pas
               de sens sur l'élément courant ; disabled_reason porte la clé de traduction dite au
               survol. badge affiche une pastille, omise quand la valeur n'est pas fournie — sur un
               onglet comme sur une entrée de son dropdown. */
            tabs: { type : Array, default: () => [] }
        },
		/* open_index : indice dans tabsComputed de l'onglet dont le volet est déployé, null quand
		   aucun ne l'est. Un seul à la fois — deux menus ouverts empileraient leurs entrées sous
		   les onglets. */
		data () {
			return {
                local_tabs: [],
                open_index: null,
				swiperOption: {
					slidesPerView: 'auto',
					spaceBetween: 0,
					preventClicks: false,
					preventClicksPropagation: false
				}
			}
        },
        created() {
            this.preinit_component()
        },
		mounted() {
            this.set_active_tab()
		},
		methods: {
            preinit_component() {
                this.local_tabs = _cloneDeep(this.tabs)
            },
			set_active_tab() {
				if(!this.local_tabs || this.local_tabs.length === 0)
					return false

				if(!this.local_tabs[0].href)
					return false

                // Les onglets à marquer sont rassemblés avant la moindre écriture, afin de ne toucher
                // ensuite que ceux dont l'état change réellement. `active` est écrit dans la liste
                // reçue en prop — que les écrans consommateurs relisent, et que ce composant
                // surveille en profondeur : éteindre puis rallumer à chaque passe relançait le
                // watcher sans fin, et le bandeau restait rendu sans aucun onglet actif.
                const actives = []
				const actual_tab = this.local_tabs.find(tab => this.matches_route(tab))

                if(actual_tab) actives.push(actual_tab)

                // L'adresse courante peut désigner l'entrée d'un menu déroulant : son parent est alors
                // marqué à son tour et le volet ouvert. Sans cela, arriver sur un sous-onglet par un
                // lien ou un rafraîchissement de page laissait le menu fermé, sans rien indiquer de
                // l'endroit où l'on se trouve.
                let open_index = null

                this.tabsComputed.forEach((tab, index) => {
                    if(!tab.dropdown) {
                        return
                    }

                    const sub_tab = tab.dropdown.find(sub_tab => !sub_tab.hidden && this.matches_route(sub_tab))

                    if(!sub_tab) {
                        return
                    }

                    actives.push(sub_tab, tab)
                    open_index = index
                })

                const mark = item => {
                    const active = actives.indexOf(item) > -1

                    if(item.active !== active) item.active = active
                }

                this.local_tabs.forEach(tab => {
                    mark(tab)

                    if(tab.dropdown) {
                        tab.dropdown.forEach(sub_tab => mark(sub_tab))
                    }
                })

                this.open_index = open_index
			},

			/**
			 * Un onglet correspond-il à l'adresse courante ? Les paramètres sont comparés valeur à
			 * valeur et en chaînes : la route les porte toujours ainsi, là où un écran peut les fournir
			 * en nombres, et une comparaison littérale des deux objets échouerait sur ce seul écart.
			 */
			matches_route(tab) {
				const route_name = this.$route.name

				if(tab.href !== route_name && !(tab.active_routes && tab.active_routes.includes(route_name))) {
					return false
				}

				if(!tab.params) {
					return true
				}

				return Object.keys(tab.params).every(key => String(tab.params[key]) === String(this.$route.params[key]))
			},

			notifyClickSuperTab(tab) {
				// Le volet se referme dès le clic, sans attendre que l'écran visé soit chargé : la
				// relecture de l'adresse le ferait aussi, mais après un délai bien visible.
				this.open_index = null
				this.notifyClickTab(tab)
			},
			notifyClickTab(tab) {
				EventBus.$emit("Swipper::TabClicked", tab)
			},
			/**
			 * Clic sur un onglet à menu déroulant : son volet s'ouvre et l'on part sur l'entrée
			 * désignée par défaut, à défaut sur la première proposée. L'ouverture est posée ici,
			 * et non laissée à une bascule : deux commandes concurrentes se défaisaient l'une
			 * l'autre selon que l'écran visé était déjà chargé ou non, et le volet se refermait
			 * dès le second passage sur l'onglet.
			 */
			selectFirstByDefault(index) {
				const sub_tabs = this.tabsComputed[index].dropdown.filter(sub_tab => !sub_tab.hidden)
				const sub_tab = sub_tabs.find(sub_tab => sub_tab.default) || sub_tabs[0]

				this.open_index = index

				// L'adresse visée est parfois déjà la courante — on revient sur l'onglet depuis son
				// propre sous-onglet : la navigation serait rejetée, autant ne pas la demander.
				if(!this.matches_route(sub_tab)) {
					this.$router.replace({ name: sub_tab.href, params: sub_tab.params })
				}
			}
		},
		computed: {
			/**
			 * Préfixe des identifiants de volets, propre à cette instance.
			 *
			 * Deux bandeaux affichés en même temps porteraient sinon les mêmes identifiants, et
			 * l'aria-controls d'un onglet désignerait le volet de l'autre.
			 *
			 * L'identifiant est lu ici et non dans le template : une boucle v-for y compile en fonction,
			 * et le module étant en mode strict, `this` y vaut undefined — seuls les identifiants nus
			 * traversent le `with` du rendu.
			 */
			collapse_prefix() {
				return `collapse-${this._uid}`
			},

			tabsComputed() {
				return this.local_tabs ? this.local_tabs.filter(t => !t.hidden) : []
            }
		},
		watch: {
			'tabs': {
				handler(val) {
					this.local_tabs = val
					// La liste reconstruite arrive sans marque d'activité : sans cette relecture, un
					// écran dont les onglets dépendent de données chargées après coup — le cas d'une
					// fiche — perd la sélection au moment où elles arrivent.
					this.set_active_tab()
				},
				deep: true
			},
			'$route' (_) {
                this.set_active_tab()
			}
		},
        components: {
            swiper,
            swiperSlide
        }
	}
</script>
